import React from 'react'

const Form1 = () => {
    return (
        <>
            <section className="content-header">
                <h1>Form1 Style</h1>
            </section>

            <section className="content">
                <div className="box">
                    <div className="box-body">


                        <div className="panel panel-success panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Documents</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <a className="btn btn-warning mr-10">
                                            <span>Save new order</span>
                                        </a>
                                        <a className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                            <span>Create new document</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <form>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="inputEmail3">Email</label>
                                        <div className="col-sm-4">
                                            <input id="inputEmail3" className="form-control" type="email" placeholder="Email" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="inputPassword3">Password</label>
                                        <div className="col-sm-4">
                                            <input id="inputPassword3" className="form-control" type="password" placeholder="Password" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="inputEmail3">Email</label>
                                        <div className="col-sm-4">
                                            <input id="inputEmail3" className="form-control" type="email" placeholder="Email" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="inputPassword3">Password</label>
                                        <div className="col-sm-4">
                                            <input id="inputPassword3" className="form-control" type="password" placeholder="Password" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-2 control-label" htmlFor="inputEmail3">Email</label>
                                        <div className="col-sm-4">
                                            <input id="inputEmail3" className="form-control" type="email" placeholder="Email" />
                                        </div>
                                        <label className="col-sm-2 control-label" htmlFor="inputPassword3">Password</label>
                                        <div className="col-sm-4">
                                            <input id="inputPassword3" className="form-control" type="password" placeholder="Password" />
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="panel-footer"> <button className="btn btn-success" type="submit">Sign in</button></div>
                        </div>

                        <div className="panel panel-success panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Documents</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <a className="btn btn-warning mr-10">
                                            <span>Save new order</span>
                                        </a>
                                        <a className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                            <span>Create new document</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Email address</label>
                                    <input id="exampleInputEmail1" className="form-control" type="email" placeholder="Email" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">Password</label>
                                    <input id="exampleInputPassword1" className="form-control" type="password" placeholder="Password" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputFile">File input</label>
                                    <input id="exampleInputFile" type="file" />
                                </div>
                                <div className="help-block">
                                    <p>Example block-level help text here.</p>
                                </div>
                                <div className="checkbox">
                                    <input type="checkbox" />Check me out
                                </div>
                                <div className="form-group">
                                    <button className="btn btn-success" type="submit">Submit</button>
                                </div>
                            </div>
                            <div className="panel-footer">Panel footer</div>
                        </div>
                        <div className="panel panel-success panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Documents</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <a className="btn btn-warning mr-10">
                                            <span>Save new order</span>
                                        </a>
                                        <a className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                            <span>Create new document</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">

                            </div>
                            <div className="panel-footer">Panel footer</div>
                        </div>

                        <div className="panel panel-info">
                            <div className="panel-heading">
                                COLLECTIVE INVESTMENT SUMMARY
                            </div>
                            <div className="panel-body">
                                <form action="" method="post">
                                    <div className="form-group">
                                        
                                        <label htmlFor="total_number_of_shares">Total Number of Shares</label>
                                        <abbr title="required">
                                        </abbr>
                                        <strong >*</strong>
                                        <input
                                            type="text"
                                            name="total_number_of_shares" className="form-control"
                                        />
                                        <label htmlFor="total_number_of_shares">Total Number of Shares</label>
                                        <abbr title="required">
                                        </abbr>
                                        <strong ></strong>
                                        <label align="center" readOnly type="text" name="total_number_of_shares" className="form-control" >10,000,000 </label>
                                        <label htmlFor="total_number_of_shares">Total Number of Shares</label>
                                        <abbr title="required">
                                        </abbr>
                                        <strong ></strong>
                                        <label align="center" readOnly type="text" name="total_number_of_shares" className="form-control" >10,000,000 </label>
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="total_number_of_shares">Total Number of Shares</label>
                                        <abbr title="required">
                                        </abbr>
                                        <strong ></strong>
                                        <label align="center" readOnly type="text" name="total_number_of_shares" className="form-control" >10,000,000 </label>
                                        <label htmlFor="total_number_of_shares">Total Number of Shares</label>
                                        <abbr title="required">
                                        </abbr>
                                        <strong ></strong>
                                        <label align="center" readOnly type="text" name="total_number_of_shares" className="form-control" >10,000,000 </label>
                                        <label htmlFor="total_number_of_shares">Total Number of Shares</label>
                                        <abbr title="required">
                                        </abbr>
                                        <strong ></strong>
                                        <label align="center" readOnly type="text" name="total_number_of_shares" className="form-control" >10,000,000 </label>
                                    </div>

                                </form>
                            </div>
                        </div>

                        <div className="box-footer"></div>
                    </div>
                </div >
            </section >
        </>
    )
}

export default Form1





